import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import RateResults from "@/pages/RateResults";
import RateDetails from "@/pages/RateDetails";
import Calculator from "@/pages/Calculator";
import ShippingLinesPage from "@/pages/ShippingLinesPage";
import LocalChargesPage from "@/pages/LocalChargesPage";
import EnquiryPage from "@/pages/EnquiryPage";
import BookingPage from "@/pages/BookingPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import TradeLanePage from "@/pages/TradeLanePage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/trade-lane/:slug" element={<TradeLanePage />} />
      <Route path="/rates" element={<RateResults />} />
      <Route path="/rates/:id" element={<RateDetails />} />
      <Route path="/calculator" element={<Calculator />} />
      <Route path="/shipping-lines" element={<ShippingLinesPage />} />
      <Route path="/local-charges" element={<LocalChargesPage />} />
      <Route path="/enquiry" element={<EnquiryPage />} />
      <Route
        path="/booking"
        element={
          <ProtectedRoute>
            <BookingPage />
          </ProtectedRoute>
        }
      />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <CustomerDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
